// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Vc","content":"Wc","crumbsList":"Xc","dropdownsWrap":"Yc"};